import store from '../store'

import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
//这里柚子引入的是element-ui中的提示框和加载框，用其他ui组件的要换一下
import {Message} from 'element-ui'
// 响应时间
axios.defaults.timeout = 5 * 1000
// 配置token

axios.defaults.headers.common['token'] = store.state.stateToken;
// 配置cookie
// axios.defaults.withCredentials = true
// 配置请求头
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
// 静态资源
// Vue.prototype.$static = ''

//这里的接口地址是你地址的相同的前半部分，方便管理
axios.defaults.baseURL = store.state.stateBaseURL
// axios.defaults.baseURL = '/api'

// var loadingInstance
// POST传参序列化(添加请求拦截器)
axios.interceptors.request.use(
  config => {
    // Message.error('数据加载中，请稍后...')
    return config
  },
  err => {
    Message.error('请求错误')
    return Promise.reject(err)
  }
)
// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  res => {
    return res
  },
  err => {
    Message.error('请求失败，请稍后再试')
    return Promise.reject(err)
  }
)


// 发送请求
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params).then(res => {
        resolve(res.data)
      },
      err => {
        reject(err.data)
      }
    ).catch(err => {

    })
  })
}

export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data)

    }).catch(err => {

    })
  })
}
